export default __webpack_public_path__ + "static/for-hire-3-e5a50604078242f6408b85052e33207c.jpg";